module.exports = __webpack_public_path__ + "static/media/press-hunt-full-logo-20-dark.4f05abbe.svg";